import type { TDataSourceDefinitionPresetSections } from './interfaces';
import { ALL_CONTINENTS, CONTINENT_COUNTRIES } from './data/country-continents';

export const FLEETS_FILTERS_SECTIONS: TDataSourceDefinitionPresetSections = {
  name: 'fleets',
  shortCode: 'fleets',
  exportRoute: 'fleets/export',
  sections: [
    {
      options: [
        {
          filterMethod: 'keywords',
          filterPropertyKeys: ['search'],
          filterMethodConfig: {
            useForSearch: true,
            title: 'Search',
            label: 'Any keywords or fleet IDs',
          },
        },
      ],
    },
    {
      options: [
        {
          filterMethod: 'combined-nested-checkboxes',
          filterMethodConfig: {
            title: 'Location',
            showChildrenLabel: 'Show countries',
            enableShowChildren: true,
            parentData: ALL_CONTINENTS,
            parentKeyName: 'continent',
            childData: CONTINENT_COUNTRIES,
            childKeyName: 'country.name',
            optionsColumns: 3,
          },
          filterPropertyKeys: ['continent', 'country.name'],
        },
      ],
      filterGroup: 'OR',
    },
    {
      options: [
        {
          filterMethod: 'reference-autocomplete',
          filterMethodConfig: {
            entityDefinitionAlias: 'categories',
            metaDataPrefix: 'data',
            entityValueField: 'name',
          },
          filterPropertyKeys: ['category.name'],
          definitionAlias: 'fleets',
        },
      ],
    },
    {
      options: [
        {
          filterMethod: 'reference-autocomplete',
          filterMethodConfig: {
            entityDefinitionAlias: 'sub-categories',
            metaDataPrefix: 'data',
            entityValueField: 'name',
          },
          filterPropertyKeys: ['sub-category.name'],
          definitionAlias: 'fleets',
        },
      ],
    },
    {
      options: [
        {
          filterMethod: 'reference-autocomplete',
          filterMethodConfig: {
            entityDefinitionAlias: 'operators',
            metaDataPrefix: 'data',
            entityValueField: 'name',
            entityDefinitionSuffix: 'operators',
          },
          filterPropertyKeys: ['operator/city.name'],
          definitionAlias: 'fleets',
        },
      ],
    },
    {
      options: [
        {
          filterMethod: 'reference-autocomplete',
          filterMethodConfig: {
            entityDefinitionAlias: 'suppliers',
            metaDataPrefix: 'data',
            entityValueField: 'name',
            entityDefinitionSuffix: 'suppliers',
          },
          filterPropertyKeys: ['supplier.name'],
          definitionAlias: 'fleets',
        },
      ],
    },
    {
      options: [
        {
          filterMethod: 'between-boxes',
          filterMethodConfig: {
            title: 'Train Set Quantity',
            minValue: 0,
            maxValue: 500,
          },
          filterPropertyKeys: ['trainSetQuantity'],
        },
      ],
    },
    {
      options: [
        {
          filterMethod: 'years-drop-down',
          filterMethodConfig: {
            title: 'Delivery Start',
            min: 2000,
            max: 2040,
          },
          filterPropertyKeys: ['deliveryStart'],
        },
      ],
    },
    {
      options: [
        {
          filterMethod: 'years-drop-down',
          filterMethodConfig: {
            title: 'Delivery End',
            min: 2000,
            max: 2040,
          },
          filterPropertyKeys: ['deliveryEnd'],
        },
      ],
    },
    {
      options: [
        {
          filterMethod: 'between-boxes',
          filterMethodConfig: {
            title: 'Number of Vehicles',
          },
          filterPropertyKeys: ['vehicleQuantity'],
        },
      ],
    },
  ],
};
